




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import data from "@/services/data/cpi-ppi";
import categories, { query_type_categories, chart_type_categories, sorting_methods_categories, statistics_categories , file_formats } from "@/services/categories";
import ComboBox from "@/components/ComboBox.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { PnetInput } from "@previnet/vue-input";
import moment from "moment";
import { clone , forEach, isNil, merge } from 'ramda';
import { it } from "vuejs-datepicker/dist/locale";
import {propertyTypes} from "@/services/properties/";
import properties, {codes} from "@/services/properties/cpi-ppi";
import { format } from "date-fns";
import Header from "@/components/Header.vue";
import BarChart from '@/components/charts/BarChart.vue';
import GroupedBarChart from '@/components/charts/GroupedBarChart.vue';
import PieChart from '@/components/charts/PieChart.vue';
import jquery from 'jquery';
import { mapGetters } from 'vuex';
import { Filter } from '@/services/filters';

const FILTER_KEY = "cpi-ppi-dashboard";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['user','fromDatabase'],
  components: {
    PnetDatePicker,
    PnetInput,
    ComboBox,
    Header,
    MultiComboBox,
    BarChart,
    GroupedBarChart,
    PieChart,
  },
  computed: {
    ...mapGetters('filters', {
      filterById: 'byId',
    })
  },
  data: function() {
    return {
      router: this.$router,
      issuesMap: {} as any,
      models: [] as any,
      statisticsMap: {} as any,
      slide: 0,
      sliding: null as any,
      actualSlide: 0,
      isCheckedCompagnia: false,
      loggedUser: this.$props.user,
      codCategoriaProdotto: categories.CPI_PPI,
      listaProdottiCensiti: [] as any[],
      showFilter: true,
      filterOptions: {
        //prodotto: [],
        compagnia: [],
        mercato: [],
        canale: [],
        distributori: [],
        modDistribuzione: [],
        ramo: [],
        tipologiaGaranzie: [],
        prodottoInCommercio: [],
        tipoAssicurazione: [],
        premioTipologia: [],
        rischiAssicurati: [],
      },
      changedFilterFields: [],
      filtroRicerca: {
        //prodotto: [] as any,
        compagnia: [] as any,
        canale: [] as any,
        mercato: undefined,
        distributori: [] as any,
        modDistribuzione: [] as any,
        ramo: undefined,
        tipologiaGaranzie: [] as any,
        prodottoInCommercio: null as any,
        inizioCommercializzazioneDaDate: Date,
        inizioCommercializzazioneADate: Date,
        fineCommercializzazioneDaDate: Date,
        fineCommercializzazioneADate: Date,
        inizioCommercializzazioneDa: String,
        inizioCommercializzazioneA: String,
        fineCommercializzazioneDa: String,
        fineCommercializzazioneA: String,
        tipoAssicurazione: undefined,
        premioTipologia: [] as any,
        rischiAssicurati: [] as any,
      },
      filtroRicercaDB: {
        prodottoCompleto: undefined,
        compagnia: [] as any,
        prodotto: [] as any,
        canale: [] as any,
        distributori: [] as any,
        modDistribuzione: [] as any,
        mercato: undefined,
        ramo: undefined,
        tipologiaGaranzie: [] as any,
        prodottoInCommercio: undefined,
        inizioCommercializzazioneDaDate: Date,
        inizioCommercializzazioneADate: Date,
        fineCommercializzazioneDaDate: Date,
        fineCommercializzazioneADate: Date,
        inizioCommercializzazioneDa: String,
        inizioCommercializzazioneA: String,
        fineCommercializzazioneDa: String,
        fineCommercializzazioneA: String,
        tipologiaAssicurazione: undefined,
        premioTipologia: [] as any,
        rischiAssicurati: [] as any,
        otherField: {
          key: null as any,
          value: null as any
        }
      },
      filtroRicercaAdapted: null,
      nomeFiltroRicercaDaSalvare: undefined,
      savedSearchFiltersList: [] as any,
      actualSavedFilter: null as any,
      operationToConfirm: "",
      msgError: "",
      msgSuccess: "",
      msgConfirmOperation: "",
      it,
      ...data,
      ...properties,
      prodottiOptions: [] as any,
      distributoriOptions: [] as any,
      compagnieOptions: [] as any,
      isAllChartsSelected: true,
      isSectionChartsSelected: {
        "CARATTERISTICHE GENERALI":true,
        "REQUISITI DI SOTTOSCRIZIONE":true,
        "GARANZIE ASSICURATIVE":true,
        "COSTI":true,
        "RETROCESSIONE ALLA DISTRIBUZIONE":true,
      },
      chartNamesArray: [],
      mapIndexSlide: {
        0: {
          sectionName:"CARATTERISTICHE GENERALI",name:"Compagnia",fieldName:"compagnia",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.compagniaOptions,sortingMethod:sorting_methods_categories.ISSUES_DESCRIPTION_COMPARE_ASC,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true,
          statistics:true,
          statisticsParams:{fieldName:"compagnia",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.COUNT,xExclude:[],legendMapping:undefined,otherOptions:[],
            statisticsTypes:[statistics_categories.SUM],
            statisticsLabelsMapping:{"sum":"Totale prodotti"}
          },
        },
        1: {sectionName:"CARATTERISTICHE GENERALI",name:"Mercato",fieldName:"mercato",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.mercatoOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        2: {sectionName:"CARATTERISTICHE GENERALI",name:"Canale",fieldName:"canale",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.canaleOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        3: {sectionName:"CARATTERISTICHE GENERALI",name:"Distributori",fieldName:"distributori",chartType:chart_type_categories.BAR_CHART,code:properties.distributoriProperty.code,options:undefined,sortingMethod:sorting_methods_categories.ISSUES_VALUE_AND_DESCRIPTION_ASC_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        4: {sectionName:"CARATTERISTICHE GENERALI",name:"Modalità di distribuzione",fieldName:"modalita_distribuzione",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.modDistribuzioneOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,isSelected:true},
        5: {sectionName:"CARATTERISTICHE GENERALI",name:"Tipologia di assicurazione",fieldName:"tipologia_assicurazione",chartType:chart_type_categories.BAR_CHART,code:properties.tipologiaAssicurazioneProperty.code,options:undefined,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        6: {sectionName:"CARATTERISTICHE GENERALI",name:"Inizio commercializzazione",fieldName:"inizio_commercializzazione",chartType:chart_type_categories.BAR_CHART,code:properties.inizioCommProperty.code,options:undefined,sortingMethod:sorting_methods_categories.ISSUES_DESCRIPTION_COMPARE_DESC,queryType:query_type_categories.BY_YEAR,fasce:undefined,legendMapping:undefined,isSelected:true},
        7: {sectionName:"REQUISITI DI SOTTOSCRIZIONE",name:"Tipologia premio",fieldName:"tipologia_premio",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.premioTipologiaOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        8: {sectionName:"REQUISITI DI SOTTOSCRIZIONE",name:"Frazionamento del premio",fieldName:"frazionamento_premio",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.frazPremioOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,xExclude:['Non previsto'],fasce:undefined,legendMapping:undefined,
          statistics:true,
          statisticsParams:{fieldName:"frazionamento_premio_consentito",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:['Non previsto'],legendMapping:undefined,
            statisticsTypes:[statistics_categories.PRODUCTS_COUNT_ON_TOT],
            statisticsLabelsMapping:{"products-count-on-tot":"Prodotti che permettono il frazionamento del premio"}
          },
          isSelected:true
        },
        9: {sectionName:"GARANZIE ASSICURATIVE",name:"Ramo",fieldName:"ramo__combination",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COMBINATION,fasce:undefined,legendMapping:undefined,isSelected:true},
        10: {sectionName:"GARANZIE ASSICURATIVE",name:"Tipologia garanzie",fieldName:"tipologia_garanzie",chartType:chart_type_categories.BAR_CHART,code:properties.tipologiaGaranzieProperty.code,options:undefined,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        11: {sectionName:"GARANZIE ASSICURATIVE",name:"Rischi assicurati - Ramo Vita",fieldName:"rischi_assicurati_ramo_vita",chartType:chart_type_categories.BAR_CHART,code:properties.rischiAssicuratiRamoVitaProperty.code,options:undefined,sortingMethod:sorting_methods_categories.ISSUES_VALUE_MIX_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,otherOptions:["LAST_COLUMNS_MIX_COMPARE#Altri rischi"],isSelected:true},
        12: {sectionName:"GARANZIE ASSICURATIVE",name:"Rischi assicurati - Ramo Danni",fieldName:"rischi_assicurati_ramo_danni",chartType:chart_type_categories.BAR_CHART,code:properties.rischiAssicuratiRamoDanniProperty.code,options:undefined,sortingMethod:sorting_methods_categories.ISSUES_VALUE_MIX_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,otherOptions:["LAST_COLUMNS_MIX_COMPARE#Altri rischi"],isSelected:true},
        13: {sectionName:"COSTI",name:"Caricamento Ramo Vita",fieldName:"costi_ramo_vita",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.costiRamoVitaProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            costi_ramo_vita:"Min.   Media   Max.",
          },
          isSelected:true
        },
        14: {sectionName:"COSTI",name:"Caricamento Ramo Danni",fieldName:"costi_ramo_danni",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.costiRamoDanniProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            costi_ramo_danni:"Min.   Media   Max.",
          },
          isSelected:true
        },
        15: {sectionName:"COSTI",name:"Interessi di frazionamento",fieldName:"interessi_frazionamento_mensile,interessi_frazionamento_bimestrale,interessi_frazionamento_trimestrale,interessi_frazionamento_quadrimestrale,interessi_frazionamento_semestrale",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.interessiFrazProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,
          fieldNameMapping:{
            interessi_frazionamento_mensile:"Mensile",
            interessi_frazionamento_bimestrale:"Bimestrale",
            interessi_frazionamento_trimestrale:"Trimestrale",
            interessi_frazionamento_quadrimestrale:"Quadrimestrale",
            interessi_frazionamento_semestrale:"Semestrale",
          },
          isSelected:true
        },
        16: {sectionName:"RETROCESSIONE ALLA DISTRIBUZIONE",name:"Retrocessione alla Distribuzione - Ramo Vita",fieldName:"retrocessione_alla_distribuzione_ramo_vita",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.retrDistrVitaProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            retrocessione_alla_distribuzione_ramo_vita:"Min.   Media   Max.",
          },
          isSelected:true
        },
        17: {sectionName:"RETROCESSIONE ALLA DISTRIBUZIONE",name:"Retrocessione alla Distribuzione - Ramo Danni",fieldName:"retrocessione_alla_distribuzione_ramo_danni",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.retrDistrDanniProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            retrocessione_alla_distribuzione_ramo_danni:"Min.   Media   Max.",
          },
          isSelected:true
        },
      } as any,
      jquery,
    };
  },
  methods: {
    storeFilter: function(filter: any, saveViewState: boolean) {
      let viewState: any = {
        slide: this.slide,
        mapIndexSlide: this.mapIndexSlide
      };
      var f: Filter = {
        id: FILTER_KEY,
        payload: filter !== undefined ? filter : this.filtroRicerca,
        changedFields: this.changedFilterFields,
        viewState: saveViewState ? viewState : {},
      }
      this.$store.dispatch('filters/set', f);
    },
    getStoredFilter: function() {
      const f: Filter = this.filterById(FILTER_KEY);
      if (f == undefined) {
        return undefined;
      }

      return f.payload;
    },
    getStoredChangedFields: function() {
      const f: Filter = this.filterById(FILTER_KEY);
      if (f == undefined) {
        return undefined;
      }

      return f.changedFields;
    },
    getStoredViewState: function() {
      const f: Filter = this.filterById(FILTER_KEY);
      if (f == undefined) {
        return undefined;
      }

      return f.viewState;
    },
    prev() {
      const vm = this as any;

      //vm.$refs.chartsCarousel.prev();
      const prevSelectedSlideIndex = vm.getPrevIsSelectedSlideIndex();
      vm.$refs.chartsCarousel.setSlide(prevSelectedSlideIndex);
    },
    next() {
      const vm = this as any;

      //vm.$refs.chartsCarousel.next();
      const nextSelectedSlideIndex = vm.getNextIsSelectedSlideIndex();
      vm.$refs.chartsCarousel.setSlide(nextSelectedSlideIndex);
    },
    filterDB: function(field: any) {
      const vm = this as any;
      if (field !== undefined) {
        let f: any = clone(vm.filtroRicercaDB);
        f = merge(f, vm.filtroRicerca);
        let k = field.key;
        let v = field.value;
        let vs = field.values;
        let min = field.min;
        let max = field.max;
        let avg = field.avg;
        let tot = field.tot;
        let count = field.count;
        let ignores = [];
        let exclusive = undefined;
        let a: any = Object.values(vm.mapIndexSlide).filter((el: any) => {
          return el.fieldName == k;
        });
        if ((a == undefined || a.length == 0) && v != undefined && v.code != undefined) {
          a = Object.values(vm.mapIndexSlide).filter((el: any) => {
            return el.code == v.code;
          });
        }
        let fasce = undefined;
        if (a != undefined && a.length == 1) {
          fasce = a[0].fasce;
          ignores = a[0].xExclude;
        }
        if (k == "inizioComm") {
          k = "inizioCommercializzazioneDaDate";
          v = vm.dateFromString("01/01/" + field.value.description);
          f[k] = v;
          k = "inizioCommercializzazioneADate";
          v = vm.dateFromString("31/12/" + field.value.description);
          f[k] = v;
        }
        if (k == "ramoCombinazione") {
          v.code = properties.ramoProperty.code;
          v.description = v.description.replaceAll(' + ', '|');
          exclusive = true;
        }
        if (fasce) {
          let r = fasce.filter((i: [string]) => {
            return i[0] == field.value.description;
          });
          if (r != undefined && r.length == 1) {
            if (r[0].length >= 3) {
              min = r[0][1];
              max = r[0][2];
            } else {
              v.description = r[0][0];
              min = undefined;
              max = undefined;
            }
          }
        }

        const filterField = vm.filtroRicerca[k];
        if (f[k] && (filterField == undefined || filterField.length == 0)) {
          f[k] = v || vs;
        } else {
          let code = undefined;
          let description = undefined;
          if (v !== undefined) {
            code = v.code;
            description = v.description;
          } else if (vs != undefined && vs.length == 1) {
            code = vs[0].code;
            description = vs[0].description;
          }
          f.otherField.key = k;
          f.otherField.value = {
            code: code,
            description: description,
            min: min,
            max: max,
            avg: avg,
            tot: tot,
            count: count,
            exclusive: exclusive,
            ignores: ignores,
          };
        }

        vm.storeFilter(vm.filtroRicerca, true);
        vm.$router.push({ name: 'database-cpi-ppi', params: { filters: f, fromDashboard: true, user: vm.loggedUser } });
      }
    },
    getPrevIsSelectedSlideIndex: function() {
      const vm = this as any;

      let prevSelectedSlideIndex = undefined;
      for (const [key, value] of Object.entries(vm.mapIndexSlide)) {
        if (key < vm.slide && (value as any).isSelected) {
          prevSelectedSlideIndex = key;
        } else if (vm.slide == key) {
          break;
        }
      }
      if (prevSelectedSlideIndex === undefined) {
        prevSelectedSlideIndex = vm.slide;
      }

      return prevSelectedSlideIndex;
    },
    getNextIsSelectedSlideIndex: function() {
      const vm = this as any;

      let foundActualSlide = false;
      let nextSelectedSlideIndex = undefined;
      for (const [key, value] of Object.entries(vm.mapIndexSlide)) {
        if (vm.slide == key) {
          foundActualSlide = true;
        } else if (key > vm.slide && foundActualSlide && (value as any).isSelected) {
          nextSelectedSlideIndex = key;
          break;
        }
      }
      if (nextSelectedSlideIndex === undefined) {
        nextSelectedSlideIndex = vm.slide;
      }

      return nextSelectedSlideIndex;
    },
    isSelected: function(fieldName: string) {
      const vm = this as any;

      let isSelected = false;
      for (const [key, value] of Object.entries(vm.mapIndexSlide)) {
        if ((value as any).name == fieldName) {
          isSelected = (value as any).isSelected;
          break;
        }
      }

      return isSelected;
    },
    changeIsSelected: function(fieldName: string) {
      const vm = this as any;
      Object.values(vm.mapIndexSlide).forEach((item: any) => {
        if (item.name === fieldName) {
          item.isSelected = !item.isSelected;
        }
      });
    },
    changeIsSectionChartsSelected: function(sectionName: string) {
      const vm = this as any;

      vm.isSectionChartsSelected[sectionName] = !vm.isSectionChartsSelected[sectionName];

      Object.values(vm.mapIndexSlide).forEach((item: any) => {
        if (item.sectionName == sectionName) {
          item.isSelected = vm.isSectionChartsSelected[sectionName]
        }
      });
    },
    changeIsAllChartsSelected: function() {
      const vm = this as any;

      vm.isAllChartsSelected = !vm.isAllChartsSelected;

      // imposto tutti i checkbox delle sezioni
      for (const [key, value] of Object.entries(vm.isSectionChartsSelected)) {
        vm.isSectionChartsSelected[key] = vm.isAllChartsSelected;
        //console.log(`${key}: ${value}`);
      }
      // imposto tutti i checkbox dei singoli grafici
      Object.values(vm.mapIndexSlide).forEach((item: any) => {
        item.isSelected = vm.isAllChartsSelected
      });
    },
    resetIsAllChartsSelected: function() {
      const vm = this as any;

      vm.isAllChartsSelected = true;

      // imposto tutti i checkbox delle sezioni
      for (const [key, value] of Object.entries(vm.isSectionChartsSelected)) {
        vm.isSectionChartsSelected[key] = vm.isAllChartsSelected;
        //console.log(`${key}: ${value}`);
      }
      // imposto tutti i checkbox dei singoli grafici
      Object.values(vm.mapIndexSlide).forEach((item: any) => {
        item.isSelected = vm.isAllChartsSelected
      });
    },
    showFilterPane: function() {
      const vm = this as any;

      vm.showFilter = !vm.showFilter;
    },
    // Si assume che i grafici siano ordinati con un progressivo senza salti di numerazione da 0 ad n, altrimenti non funziona.
    getSlidesIndexByName: function() {
      const vm = this as any;

      Object.values(vm.mapIndexSlide).forEach((item: any) => {
        vm.chartNamesArray.push(item.name);
      });
    },
    resetFilterOptions: async function() {
      const vm = this as any;

      //vm.filterOptions.prodotto = vm.prodottiOptions;
      vm.filterOptions.compagnia = vm.compagnieOptions;
      vm.filterOptions.mercato = vm.mercatoOptions;
      vm.filterOptions.canale = vm.canaleOptions;
      vm.filterOptions.distributori = vm.distributoriOptions;
      vm.filterOptions.modDistribuzione = vm.modDistribuzioneOptions;
      vm.filterOptions.ramo = vm.ramoOptions;
      vm.filterOptions.tipologiaGaranzie = vm.tipologiaGaranzieOptions;
      vm.filterOptions.prodottoInCommercio = vm.yesNoOptions;
      vm.filterOptions.tipoAssicurazione = vm.tipologiaAssicurazioneOptions;
      vm.filterOptions.premioTipologia = vm.premioTipologiaOptions;
      vm.filterOptions.rischiAssicurati = vm.rischiAssicuratiOptions;
    },
    emptyNoDynamicFiltroRicerca: async function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
      vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.fineCommercializzazioneADate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
      vm.filtroRicerca.inizioCommercializzazioneA = undefined;
      vm.filtroRicerca.fineCommercializzazioneDa = undefined;
      vm.filtroRicerca.fineCommercializzazioneA = undefined;
    },
    emptyFilterOptions: async function(indexOfChangedField: number) {
      const vm = this as any;

      /*if (!vm.changedFilterFields.includes('prodotto') ||
          vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
        vm.filterOptions.prodotto = [];
      }*/
      if (!vm.changedFilterFields.includes('compagnia') ||
          vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
        vm.filterOptions.compagnia = [];
      }
      if (!vm.changedFilterFields.includes('mercato') ||
          vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
        vm.filterOptions.mercato = [];
      }
      if (!vm.changedFilterFields.includes('canale') ||
          vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
        vm.filterOptions.canale = [];
      }
      if (!vm.changedFilterFields.includes('distributori') ||
          vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
        vm.filterOptions.distributori = [];
      }
      if (!vm.changedFilterFields.includes('modDistribuzione') ||
          vm.changedFilterFields.indexOf('modDistribuzione') > indexOfChangedField) {
        vm.filterOptions.modDistribuzione = [];
      }
      if (!vm.changedFilterFields.includes('ramo') ||
          vm.changedFilterFields.indexOf('ramo') > indexOfChangedField) {
        vm.filterOptions.ramo = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzie') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzie') > indexOfChangedField) {
        vm.filterOptions.tipologiaGaranzie = [];
      }
      if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
          vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
        vm.filterOptions.prodottoInCommercio = [];
      }
      if (!vm.changedFilterFields.includes('tipoAssicurazione') ||
          vm.changedFilterFields.indexOf('tipoAssicurazione') > indexOfChangedField) {
        vm.filterOptions.tipoAssicurazione = [];
      }
      if (!vm.changedFilterFields.includes('premioTipologia') ||
          vm.changedFilterFields.indexOf('premioTipologia') > indexOfChangedField) {
        vm.filterOptions.premioTipologia = [];
      }
      if (!vm.changedFilterFields.includes('rischiAssicurati') ||
          vm.changedFilterFields.indexOf('rischiAssicurati') > indexOfChangedField) {
        vm.filterOptions.rischiAssicurati = [];
      }
    },
    emptyFiltroRicerca: async function(indexOfChangedField: number) {
      const vm = this as any;

      /*if (!vm.changedFilterFields.includes('prodotto') ||
          vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
        vm.filtroRicerca.prodotto = []
      }*/
      if (!vm.changedFilterFields.includes('compagnia') ||
          vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
        vm.filtroRicerca.compagnia = [];
      }
      if (!vm.changedFilterFields.includes('mercato') ||
          vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
        vm.filtroRicerca.mercato = undefined;
      }
      if (!vm.changedFilterFields.includes('canale') ||
          vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
        vm.filtroRicerca.canale = [];
      }
      if (!vm.changedFilterFields.includes('distributori') ||
          vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
        vm.filtroRicerca.distributori = [];
      }
      if (!vm.changedFilterFields.includes('modDistribuzione') ||
          vm.changedFilterFields.indexOf('modDistribuzione') > indexOfChangedField) {
        vm.filtroRicerca.modDistribuzione = [];
      }
      if (!vm.changedFilterFields.includes('ramo') ||
          vm.changedFilterFields.indexOf('ramo') > indexOfChangedField) {
        vm.filtroRicerca.ramo = undefined;
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzie') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzie') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaGaranzie = [];
      }
      if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
          vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
        vm.filtroRicerca.prodottoInCommercio = null;
      }
      if (!vm.changedFilterFields.includes('tipoAssicurazione') ||
          vm.changedFilterFields.indexOf('tipoAssicurazione') > indexOfChangedField) {
        vm.filtroRicerca.tipoAssicurazione = undefined;
      }
      if (!vm.changedFilterFields.includes('premioTipologia') ||
          vm.changedFilterFields.indexOf('premioTipologia') > indexOfChangedField) {
        vm.filtroRicerca.premioTipologia = [];
      }
      if (!vm.changedFilterFields.includes('rischiAssicurati') ||
          vm.changedFilterFields.indexOf('rischiAssicurati') > indexOfChangedField) {
        vm.filtroRicerca.rischiAssicurati = [];
      }
    },
    emptyChangedFilterFields() {
      const vm = this as any;

      vm.changedFilterFields = [];
    },
    onFilterSearchClick() {
      const vm = this as any;

      vm.showFilter = false;

      // si attiva il primo grafico selezionato
      for (const [key, value] of Object.entries(vm.mapIndexSlide)) {
        if ((value as any).isSelected) {
          vm.slide = parseInt(key);
          break;
        }
      }

      vm.onSlideStart(vm.slide);
    },
    resetFilterOptionsAndEmptyFiltroRicerca() {
      const vm = this as any;

      vm.resetFilterOptions();
      vm.emptyNoDynamicFiltroRicerca();
      vm.emptyFiltroRicerca(-1);
      vm.emptyChangedFilterFields();
      vm.resetIsAllChartsSelected();
      vm.storeFilter();
    },
    repopulateFiltersOptionsChangedCompagnia: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('compagnia');
    },
    /*repopulateFiltersOptionsChangedProdotto: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('prodotto');
    },*/
    repopulateFiltersOptionsChangedDistributori: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('distributori');
    },
    repopulateFiltersOptionsChangedCanale: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('canale');
    },
    repopulateFiltersOptionsChangedModDistribuzione: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('modDistribuzione');
    },
    repopulateFiltersOptionsChangedTipologiaGaranzie: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaGaranzie');
    },    
    repopulateFiltersOptionsChangedGaranzie: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('garanzie');
    },
    repopulateFiltersOptionsChangedTipologiaProdotto: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaProdotto');
    },
    repopulateFiltersOptionsChangedPremioTipologia: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('premioTipologia');
    },
    repopulateFiltersOptionsChangedRischiAssicurati: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('rischiAssicurati');
    },    
    repopulateFiltersOptions: async function(changedFieldName: string) {
      const vm = this as any;

      vm.$loadingService.startLoading("loading");

      vm.listaProdottiCensiti = []; //clean

      // mantenere l'ordine!
      if (!vm.changedFilterFields.includes(changedFieldName)) {
        vm.changedFilterFields.push(changedFieldName);
      }
      const indexOfChangedField = vm.changedFilterFields.indexOf(changedFieldName)
      vm.emptyFilterOptions(indexOfChangedField);
      vm.emptyFiltroRicerca(indexOfChangedField);
      if (indexOfChangedField + 1 < vm.changedFilterFields.length) {
        vm.changedFilterFields.splice(indexOfChangedField+1, (vm.changedFilterFields.length-indexOfChangedField+1));
      }
      if (vm.filtroRicerca[changedFieldName] === undefined ||
          vm.filtroRicerca[changedFieldName] === null ||
          vm.filtroRicerca[changedFieldName].length == 0) {
        vm.changedFilterFields.pop();
      }
      //console.log(JSON.stringify(vm.filtroRicerca[changedFieldName]));
      //console.log(indexOfChangedField  + " " + changedFieldName + " vm.changedFilterFields " + JSON.stringify(vm.changedFilterFields));

      const serviceCallReturnValue = await requestService.getProductsList(vm.filtroRicerca,vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.listaProdottiCensiti = result;

          let i;
          for (i = 0; i < vm.listaProdottiCensiti.length; i++) {
            if (vm.listaProdottiCensiti[i].properties[0] != undefined) {
              const properties = vm.listaProdottiCensiti[i].properties;

              /*// Prodotto
              if (!vm.changedFilterFields.includes('prodotto') ||
                  vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
                let filterProdottoOption = vm.getProperty(properties, codes.ProdottoProperty);
                vm.pushOptionValue(filterProdottoOption,vm.filterOptions.prodotto);
              }*/

              // Compagnia
              if (!vm.changedFilterFields.includes('compagnia') ||
                  vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
                let filterCompagniaOption = vm.getProperty(properties, codes.compagniaProperty);
                vm.pushOptionValues(filterCompagniaOption,vm.filterOptions.compagnia);
              }

              // Mercato
              if (!vm.changedFilterFields.includes('mercato') ||
                  vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
                let filterMercatoOption = vm.getProperty(properties, codes.mercatoProperty);
                vm.pushOptionValues(filterMercatoOption,vm.filterOptions.mercato);
              }

              // Canale
              if (!vm.changedFilterFields.includes('canale') ||
                  vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
                let filterCanaleOption = vm.getProperty(properties, codes.canaleProperty);
                vm.pushOptionValues(filterCanaleOption,vm.filterOptions.canale);
              }

              // Distributori
              if (!vm.changedFilterFields.includes('distributori') ||
                  vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
                let filterDistributoriOption = vm.getProperty(properties, codes.distributoriProperty);
                vm.pushOptionStringList(filterDistributoriOption,vm.filterOptions.distributori,'distributori');
              }

              // Modalità di distribuzione
              if (!vm.changedFilterFields.includes('modDistribuzione') ||
                  vm.changedFilterFields.indexOf('modDistribuzione') > indexOfChangedField) {
                let filterModDistribuzioneOption = vm.getProperty(properties, codes.modDistribuzioneProperty);
                vm.pushOptionValues(filterModDistribuzioneOption,vm.filterOptions.modDistribuzione);
              }

              // Ramo
              if (!vm.changedFilterFields.includes('ramo') ||
                  vm.changedFilterFields.indexOf('ramo') > indexOfChangedField) {
                let filterRamoOption = vm.getProperty(properties, codes.ramoProperty);
                vm.pushOptionValues(filterRamoOption,vm.filterOptions.ramo);
              }

              // Tipologia Garanzie
              if (!vm.changedFilterFields.includes('tipologiaGaranzie') ||
                  vm.changedFilterFields.indexOf('tipologiaGaranzie') > indexOfChangedField) {
                let filterTipologiaGaranzieOption = vm.getProperty(properties, codes.tipologiaGaranzieProperty);
                vm.pushOptionValues(filterTipologiaGaranzieOption,vm.filterOptions.tipologiaGaranzie);
              }

              // Prodotto in commercio
              if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
                  vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
                const prodCommercio = vm.getProperty(properties, codes.prodCommercioProperty);
                let filterProdottoInCommercioOption = { code : (prodCommercio.code == "16.1" ? true : false) , value : prodCommercio.value };
                vm.pushOptionValue(filterProdottoInCommercioOption,vm.filterOptions.prodottoInCommercio);
              }

              // Tipologia di assicurazione
              if (!vm.changedFilterFields.includes('tipoAssicurazione') ||
                  vm.changedFilterFields.indexOf('tipoAssicurazione') > indexOfChangedField) {
                let filterTipoAssicurazioneOption = vm.getProperty(properties, codes.tipologiaAssicurazioneProperty);
                vm.pushOptionValue(filterTipoAssicurazioneOption,vm.filterOptions.tipoAssicurazione);
              }

              // Tipologia premio
              if (!vm.changedFilterFields.includes('premioTipologia') ||
                  vm.changedFilterFields.indexOf('premioTipologia') > indexOfChangedField) {
                let filterPremioTipologiaOption = vm.getProperty(properties, codes.premioTipologiaProperty);
                vm.pushOptionValues(filterPremioTipologiaOption,vm.filterOptions.premioTipologia);
              }

              // Rischi assicurati (fusione di vita e danni)
              if (!vm.changedFilterFields.includes('rischiAssicurati') ||
                  vm.changedFilterFields.indexOf('rischiAssicurati') > indexOfChangedField) {
                const filterRischiAssicuratiRamoVitaOption = vm.getProperty(properties, codes.retrDistrVitaProperty);
                const filterRischiAssicuratiRamoDanniOption = vm.getProperty(properties, codes.retrDistrDanniProperty);
                const filterRischiAssicuratiRamoVitaOptionInDomain = vm.getValuesInDomain(filterRischiAssicuratiRamoVitaOption.values,data.rischiAssicuratiOptions);
                const filterRischiAssicuratiRamoDanniOptionInDomain = vm.getValuesInDomain(filterRischiAssicuratiRamoDanniOption.values,data.rischiAssicuratiOptions);
                vm.pushOptionValuesWithMerge(filterRischiAssicuratiRamoVitaOptionInDomain,vm.filterOptions.rischiAssicurati);
                vm.pushOptionValuesWithMerge(filterRischiAssicuratiRamoDanniOptionInDomain,vm.filterOptions.rischiAssicurati);
              }
            }
          }

          // sort rischiAssicurati
          vm.filterOptions.rischiAssicurati.sort( vm.optionCodeCompare );

          return null;
        })
        .catch(function(e) {
          console.log(e);
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },
    getProperty: function(propertyList: any, code: string) {
      let res = undefined;
      const regexCode = /^([0-9]+)([a-z]*)/i;
      let codePrefix = undefined;
      let codeSuffix = undefined;
      const codeMatch = regexCode.exec(code);
      let re: any = undefined;
      if (codeMatch) {
        codePrefix = codeMatch[1] || "";
        codeSuffix = codeMatch[2] || "";
        re = new RegExp(`^${codePrefix}\\.[0-9]${codeSuffix}`);
      }
      const p = propertyList.find((p: any) => {
        let match = false;
        const equals = p.code === code;
        if (!equals && re != undefined) {
          match = re.test(p.code);
        }
        return equals || match;
      });
      return p || {};
    },
    homeProdotti: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    back: function() {
      const vm = this as any;
      vm.$router.go(-1);
    },
    isAdmin: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0;
      }
      return false;
    },
    isAdvanced: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('advanced') >= 0;
      }
      return false;
    },
    getCodeFromDescription(description: string, options: any) {
      let code = undefined;

      options.forEach(function(option: any) {
        if (option.description == description) {
          code = option.code;
          return;
        }
      });

      return code;
    },
    getDescriptionFromCode(code: string, options: any) {
      let description = undefined;

      options.forEach(function(option: any) {
        if (option.code == code) {
          description = option.description;
          return;
        }
      });

      return description;
    },
    onSlideStartCompagnia() {
      const vm = this as any;

      vm.isCheckedCompagnia = !vm.isCheckedCompagnia;

      vm.onSlideStart();
    },
    onSlideStart: async function(slide: any) {
      const vm = this as any;

      if (vm.actualSlide == slide && slide != 0) {
        return;
      }

      jquery(".control-tooltip").hide();

      const fieldNamesSeparator = ",";

      vm.sliding = true

      //...toppa da risolvere con metodo a parte...
      if (typeof(slide) === 'number') {
        vm.actualSlide = slide;
      } else {
        slide = vm.actualSlide; //utilizzo da pulsante CERCA
      }

      vm.models = [];

      vm.setDatePropertiesValue();

      const fieldName = vm.mapIndexSlide[slide].fieldName;
      const fieldNames = fieldName.split(fieldNamesSeparator);
      const chartType = vm.mapIndexSlide[slide].chartType;
      const queryType = vm.mapIndexSlide[slide].queryType;
      const xExclude = vm.mapIndexSlide[slide].xExclude;
      const code = vm.mapIndexSlide[slide].code;
      const options = vm.mapIndexSlide[slide].options;
      const sortingMethodStr = vm.mapIndexSlide[slide].sortingMethod;
      const fasce = vm.mapIndexSlide[slide].fasce;
      const legendMapping = vm.mapIndexSlide[slide].legendMapping;
      const fieldNameMapping = vm.mapIndexSlide[slide].fieldNameMapping;
      let otherOptions = vm.mapIndexSlide[slide].otherOptions;
      const statistics = vm.mapIndexSlide[slide].statistics;
      const statisticsTypes = vm.mapIndexSlide[slide].statisticsTypes;
      const statisticsLabelsMapping = vm.mapIndexSlide[slide].statisticsLabelsMapping;
      const statisticsParams = vm.mapIndexSlide[slide].statisticsParams;
      //const sortingMethod = vm.getSortingMethod(sortingMethodStr);

      // per alcuni campi come "mercato" occorrono alcuni adattamenti per fare in modo che il filtro sia corretto per il backend
      vm.storeFilter(vm.filtroRicerca, false);
      vm.filtroRicercaAdapted = clone(vm.filtroRicerca);
      //
      vm.filtroRicercaAdapted.mercato = [] as any;
      if (vm.filtroRicerca.mercato !== undefined && !this.isEmptyOrSpaces(vm.filtroRicerca.mercato)) {
        vm.filtroRicercaAdapted.mercato = [{code:vm.filtroRicerca.mercato, description:vm.getDescriptionFromCode(vm.filtroRicerca.mercato, data.mercatoOptions)}]
      }
      //
      vm.filtroRicercaAdapted.prodottoInCommercio = undefined;
      if (vm.filtroRicerca.prodottoInCommercio !== undefined) {
        if (vm.filtroRicerca.prodottoInCommercio == true) {
          vm.filtroRicercaAdapted.prodottoInCommercio = "Sì";
        } else if (vm.filtroRicerca.prodottoInCommercio == false) {
          vm.filtroRicercaAdapted.prodottoInCommercio = "No";
        } 
        if (vm.filtroRicercaAdapted.prodottoInCommercio === undefined) {
          vm.filtroRicercaAdapted.prodottoInCommercio = vm.getDescriptionFromCode(vm.filtroRicerca.prodottoInCommercio, data.yesNoOptions);
        }
      }
      //
      vm.filtroRicercaAdapted.tipoAssicurazione = [] as any;
      if (vm.filtroRicerca.tipoAssicurazione !== undefined && !this.isEmptyOrSpaces(vm.filtroRicerca.tipoAssicurazione)) {
        vm.filtroRicercaAdapted.tipoAssicurazione = [{code:vm.filtroRicerca.tipoAssicurazione, description:vm.getDescriptionFromCode(vm.filtroRicerca.tipoAssicurazione, data.tipologiaAssicurazioneOptions)}];
      }
      //
      vm.filtroRicercaAdapted.tipologiaPremio = [] as any;
      if (vm.filtroRicerca.premioTipologia !== undefined && vm.filtroRicerca.premioTipologia !== null) {
        vm.filtroRicerca.premioTipologia.forEach((pt: any) => {
          vm.filtroRicercaAdapted.tipologiaPremio.push({code:pt.code, description:pt.description});
        });
      }
      //
      vm.filtroRicercaAdapted.ramo = [] as any;
      if (vm.filtroRicerca.ramo !== undefined && !this.isEmptyOrSpaces(vm.filtroRicerca.ramo)) {
        vm.filtroRicercaAdapted.ramo = [{code:vm.filtroRicerca.ramo, description:vm.getDescriptionFromCode(vm.filtroRicerca.ramo, data.ramoOptions)}]
      }

      //
      let iMap = null as any;

      let params = [] as any;
      fieldNames.forEach(function(fieldName: string) {
        if ((fieldName == 'compagnia' && vm.isCheckedCompagnia)) {
          if (otherOptions === undefined || otherOptions === null) {
            otherOptions = [];
          }
          otherOptions.push("prodotti_collegati_as_one");
        }
        params.push({fieldName:fieldName,queryType:queryType,xExclude:xExclude,sortingMethod:sortingMethodStr,dbSearchFilter:vm.filtroRicercaAdapted,category:categories.CPI_PPI,fasce:fasce,legendMapping:legendMapping,fieldNameMapping:fieldNameMapping,otherOptions:otherOptions,isStatistics:statistics,statisticsTypes:statisticsTypes,statisticsLabelsMapping:statisticsLabelsMapping,statisticsParams:statisticsParams});
      });

      const serviceCallReturnValue = await requestService.getDataForChart(params)
        .then(handleResponse)
        .then((result: any) => {
          iMap = result.issuesMap;
          // ordinamento in base a campo fieldName
          let iMapSorted = iMap as any; // iMap viene tornato ordinato già da backend perché è utilizzata LinkedHashMap
          /* -- codice superfluo, serviva per ordinamento quando a backend non era utilizzata LinkedHashMap
          let iMapSorted = {} as any;
          fieldNames.forEach(function(fieldName: string) {
            Object.keys(iMap).forEach(function(fn: string) {
              if (fn == fieldName) {
                iMapSorted[fn] = iMap[fn];
              }
            });
          });*/

          // valorizzazione code in quanto non tornati dal servizio
          /*Object.keys(iMapSorted).forEach(function(fn: string) {
            iMapSorted[fn].forEach(function(issue: any) {
              if (code != undefined) {
                issue.code = code;
              } else {
                issue.code = vm.getCodeFromDescription(issue.description, options);
              }
            });
          });*/

          if (iMapSorted != null) {
            // rielaboro i dati a seconda del tipo di grafico da creare
            if (chart_type_categories.GROUPED_BAR_CHART == chartType) {
              vm.models = [];

              Object.keys(iMapSorted).forEach(function(fn: string) {
                let obj = {} as any;
                obj["model_name"] = fn;

                iMapSorted[fn].forEach((issue: any) => {
                  obj[issue.description] = issue.value;
                });

                vm.models.push(obj);
              });
            } else {
              /*Object.keys(iMapSorted).forEach(function(fn: string) {
                iMapSorted[fn] = iMapSorted[fn].sort(sortingMethod);
              });*/
              this.issuesMap = iMapSorted;
            }
          }

          return null;
        })
        .catch(function(e) {
          console.log("Error in getDataForChart for field " + JSON.stringify(fieldNames));
        });

      if (statistics) {
        if (statisticsParams !== undefined && statisticsParams !== null) {
          params[0].statisticsParams.dbSearchFilter = vm.filtroRicercaAdapted;
          params[0].statisticsParams.category = categories.CPI_PPI;
        }

        const statisticServiceCallReturnValue = await requestService.getStatisticsForChart(params)
          .then(handleResponse)
          .then((result: any) => {
            this.statisticsMap = result.issuesMap;

            return null;
          })
          .catch(function(e) {
            console.log("Error in getStatisticsDataForChart for field " + JSON.stringify(fieldNames));
          });
      }
    },
    onSlideEnd(slide: any) {
      this.sliding = false
    },
    /* formato:
      this.issues = {
          compagnia: [
            {xVal: "Allianz", xCode: "2.3", issues: 4},
            {xVal: "Cardif", xCode: "2.21", issues: 3},
            ...
          ],
          canale: [
            {xVal: "Banca", xCode: "3.1", issues: 5},
            {xVal: "Consulenti Finanziari", xCode: "3.2", issues: 3},
            ...
          ],
        };
    */
    getStartingIssues() {
      this.onSlideStart(this.slide); // starting sliding at slide 0
    },
    getPropertyValues: async function() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");

      const serviceCallReturnValue = await requestService.getPropertyValues(vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.prodottiOptions = result.prodotti;
          vm.distributoriOptions = result.distributori;
          vm.compagnieOptions = result.compagnie;
        })
        .catch(function(e) {
          console.log(e);
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },
    getMinFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let minVal = vm.getOneStatisticFromStatistics(statisticsMapItem, 'min');

      return minVal;
    },
    getAvgFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let avgVal = vm.getOneStatisticFromStatistics(statisticsMapItem, 'avg');

      return avgVal;
    },
    getMaxFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let maxVal = vm.getOneStatisticFromStatistics(statisticsMapItem, 'max');

      return maxVal;
    },
    getProductsCountFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let pCountVal = vm.getOneStatisticFromStatistics(statisticsMapItem, 'products-count');

      return pCountVal;
    },
    getProductsCountOnTotFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let pCountOnTotVal = vm.getOneStatisticFromStatistics(statisticsMapItem, 'products-count-on-tot');

      return pCountOnTotVal;
    },
    getSumFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let pCountOnTotVal = vm.getOneStatisticFromStatistics(statisticsMapItem, statistics_categories.SUM);

      return pCountOnTotVal;
    },
    getOneStatisticFromStatistics: function(statisticsMapItem: any, statisticName: string) {
      let retVal = undefined;

      if (statisticsMapItem !== undefined && statisticsMapItem !== null) {
        statisticsMapItem.forEach((s: any) => {
          if (s.description == statisticName) {
            retVal = s.value;
          }
        });
      }

      return retVal;
    },
    inizializzaFiltroRicerca: function() {
      const vm = this as any;

      const storedFilter = vm.getStoredFilter();
      if (storedFilter == undefined) {
        vm.filtroRicerca.prodottoCompleto = true;
        vm.filtroRicerca.compagnia = [] as any;
        //vm.filtroRicerca.prodotto = [] as any;
        vm.filtroRicerca.canale = [] as any;
        vm.filtroRicerca.distributori = [] as any;
        vm.filtroRicerca.modDistribuzione = [] as any;
        vm.filtroRicerca.mercato = undefined;
        vm.filtroRicerca.ramo = undefined;
        vm.filtroRicerca.tipologiaGaranzie = [] as any;
        vm.filtroRicerca.prodottoInCommercio = null;
        vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
        vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
        vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
        vm.filtroRicerca.fineCommercializzazioneADate = undefined;
        vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
        vm.filtroRicerca.inizioCommercializzazioneA = undefined;
        vm.filtroRicerca.fineCommercializzazioneDa = undefined;
        vm.filtroRicerca.fineCommercializzazioneA = undefined;
        vm.filtroRicerca.tipoAssicurazione = undefined;
        vm.filtroRicerca.premioTipologia = [] as any;
        vm.filtroRicerca.rischiAssicurati = [] as any;
      } else {
        vm.filtroRicerca = storedFilter;
        const viewState = vm.getStoredViewState();
        if (vm.fromDatabase && viewState != undefined && viewState.slide != undefined && viewState.mapIndexSlide != undefined) {
          vm.slide = viewState.slide;
          vm.mapIndexSlide = viewState.mapIndexSlide;
          vm.showFilter = false;
        }
        var f: Filter = {
          id: FILTER_KEY,
          payload: vm.filtroRicerca,
          changedFields: vm.getStoredChangedFields(),
          viewState: {},
        }
        this.$store.dispatch('filters/set', f);
      }

      const storedChangedFields = vm.getStoredChangedFields();
      if (storedChangedFields != undefined) {
        vm.changedFilterFields = storedChangedFields;
      } else {
        vm.emptyChangedFilterFields();
      }
    },
    pushOptionValue(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      let isOptionPresent = false;
      filter.forEach((o: any) => {
        if (o.description == filterOptionToInsert.value) {
          isOptionPresent = true;
        }
      });
      if (!isOptionPresent && !vm.isEmptyOrSpaces(filterOptionToInsert.value)) {
        filter.push({ code : filterOptionToInsert.code , description : filterOptionToInsert.value });
      }
    },
    pushOptionValues(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      filterOptionToInsert.values.forEach((v: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          if (o.code == v.code && o.description == v.description) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent) {
          filter.push({ code : v.code , description : v.description })
        }
      });
    },
    pushOptionValuesWithMerge(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      filterOptionToInsert.forEach((v: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          const vOptionCode = "." + v.code.split(".")[1];
          const oOptionCode = "." + o.code.split(".")[1];
          if (oOptionCode == vOptionCode && o.description == v.description) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent) {
          const vOptionCode = "." + v.code.split(".")[1];
          filter.push({ code : vOptionCode , description : v.description })
        }
      });
    },
    optionCodeCompare(a: any, b: any) {
      const aCode = parseInt(a.code.substring(1)); //elimina il '.' iniziale
      const bCode = parseInt(b.code.substring(1)); //elimina il '.' iniziale

      if ( aCode < bCode ){
        return -1;
      }
      if ( aCode > bCode ){
        return 1;
      }
      return 0;
    },
    getValuesInDomain(values: any, domain: any) {
      let retValues = [] as any;

      values.forEach((v: any) => {
        domain.forEach((item: any) => {
          const optionCodeTrailer = v.code.split('.')[1];
          const itemCodeTrailer = item.code.split('.')[1];
          if (optionCodeTrailer == itemCodeTrailer) {
            retValues.push({code:v.code,description:v.description});
          }
        });
      });

      return retValues;
    },
    pushOptionStringList(filterOptionToInsert: any, filter: any, fieldName: string) {
      const vm = this as any;

      filterOptionToInsert.stringList.forEach((s: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          if (o.description == s.value) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent && !vm.isEmptyOrSpaces(s.value)) {
          let index = filter.length;
          filter.push({ code : categories.CPI_PPI + "-" + fieldName + "-" + index, description : s.value });
        }
      });
    },
    exportChartData: async function(fileFormat: string, flagExportAll: boolean) {
      const vm = this as any;
      vm.startLoading();

      const fieldNamesSeparator = ",";

      let params = [] as any;
      if (flagExportAll !== true) {
        const fieldName = vm.mapIndexSlide[vm.actualSlide].fieldName;
        const fieldNames = fieldName.split(fieldNamesSeparator);
        const queryType = vm.mapIndexSlide[vm.actualSlide].queryType;
        const chartType = vm.mapIndexSlide[vm.actualSlide].chartType;
        const chartName = vm.mapIndexSlide[vm.actualSlide].name;
        const xExclude = vm.mapIndexSlide[vm.actualSlide].xExclude;
        const sortingMethodStr = vm.mapIndexSlide[vm.actualSlide].sortingMethod;
        const fasce = vm.mapIndexSlide[vm.actualSlide].fasce;
        const legendMapping = vm.mapIndexSlide[vm.actualSlide].legendMapping;
        const fieldNameMapping = vm.mapIndexSlide[vm.actualSlide].fieldNameMapping;
        let otherOptions = vm.mapIndexSlide[vm.actualSlide].otherOptions;
        const statistics = vm.mapIndexSlide[vm.actualSlide].statistics;
        const statisticsTypes = vm.mapIndexSlide[vm.actualSlide].statisticsTypes;
        const statisticsLabelsMapping = vm.mapIndexSlide[vm.actualSlide].statisticsLabelsMapping;
        const statisticsParams = vm.mapIndexSlide[vm.actualSlide].statisticsParams;

        if (statisticsParams !== undefined && statisticsParams !== null) {
          statisticsParams.dbSearchFilter = vm.filtroRicercaAdapted;
          statisticsParams.category = categories.CPI_PPI;
        }

        fieldNames.forEach(function(fieldName: string) {
          if ((fieldName == 'compagnia' && vm.isCheckedCompagnia)) {
            if (otherOptions === undefined || otherOptions === null) {
              otherOptions = [];
            }
            otherOptions.push("prodotti_collegati_as_one");
          }
          params.push({fieldName:fieldName,queryType:queryType,xExclude:xExclude,sortingMethod:sortingMethodStr,dbSearchFilter:vm.filtroRicercaAdapted,category:categories.CPI_PPI,chartType:chartType,chartName:chartName,fasce:fasce,legendMapping:legendMapping,fieldNameMapping:fieldNameMapping,otherOptions:otherOptions,isStatistics:statistics,statisticsTypes:statisticsTypes,statisticsLabelsMapping:statisticsLabelsMapping,statisticsParams:statisticsParams});
        });
      } else {
        Object.keys(vm.mapIndexSlide).forEach(function(slideIndex: any) {
          if (vm.mapIndexSlide[slideIndex].isSelected) {
            const fieldName = vm.mapIndexSlide[slideIndex].fieldName;
            const fieldNames = fieldName.split(fieldNamesSeparator);
            const queryType = vm.mapIndexSlide[slideIndex].queryType;
            const chartType = vm.mapIndexSlide[slideIndex].chartType;
            const chartName = vm.mapIndexSlide[slideIndex].name;
            const xExclude = vm.mapIndexSlide[slideIndex].xExclude;
            const sortingMethodStr = vm.mapIndexSlide[slideIndex].sortingMethod;
            const fasce = vm.mapIndexSlide[slideIndex].fasce;
            const legendMapping = vm.mapIndexSlide[slideIndex].legendMapping;
            const fieldNameMapping = vm.mapIndexSlide[slideIndex].fieldNameMapping;
            let otherOptions = vm.mapIndexSlide[slideIndex].otherOptions;
            const statistics = vm.mapIndexSlide[slideIndex].statistics;
            const statisticsTypes = vm.mapIndexSlide[slideIndex].statisticsTypes;
            const statisticsLabelsMapping = vm.mapIndexSlide[slideIndex].statisticsLabelsMapping;
            const statisticsParams = vm.mapIndexSlide[slideIndex].statisticsParams;
  
            if (statisticsParams !== undefined && statisticsParams !== null) {
              statisticsParams.dbSearchFilter = vm.filtroRicercaAdapted;
              statisticsParams.category = categories.CPI_PPI;
            }
  
            fieldNames.forEach(function(fieldName: string) {
              if ((fieldName == 'compagnia' && vm.isCheckedCompagnia)) {
                if (otherOptions === undefined || otherOptions === null) {
                  otherOptions = [];
                }
                otherOptions.push("prodotti_collegati_as_one");
              }
              params.push({fieldName:fieldName,queryType:queryType,xExclude:xExclude,sortingMethod:sortingMethodStr,dbSearchFilter:vm.filtroRicercaAdapted,category:categories.CPI_PPI,chartType:chartType,chartName:chartName,fasce:fasce,legendMapping:legendMapping,fieldNameMapping:fieldNameMapping,otherOptions:otherOptions,isStatistics:statistics,statisticsTypes:statisticsTypes,statisticsLabelsMapping:statisticsLabelsMapping,statisticsParams:statisticsParams});
            });
          }
        });
      }

      let contentType = '';
      let fileName = '';
      const filtro = vm.filtroRicerca;
      const serviceCallReturnValue = await requestService
        .extractChartData(params,fileFormat)
        .then((response: any) => {
          const headerContentType = response.headers.get("content-type");
          contentType = headerContentType !== null ? headerContentType : 'application/octet-stream';
          return response.blob();
        })
        .then((blob: any) => {
          fileName = 'chart-data-export.' + fileFormat;          
          vm.downloadDocFromBlob(blob, fileName, contentType);
        })
        .catch((e) => {
          console.log(e);
          vm.openModalError("Errore generico");
        })

      vm.stopLoading();
    },
    exportChartDataCsv: async function() {
      const vm = this as any;

      vm.exportChartData(file_formats.CSV,false);
    },
    exportChartDataPptx: async function() {
      const vm = this as any;

      vm.exportChartData(file_formats.POWERPOINT,false);
    },
    exportAllChartDataPptx: async function() {
      const vm = this as any;

      vm.exportChartData(file_formats.POWERPOINT,true);
    },
    downloadDocFromBlob(blob: any, name: string, contentType: string) {
      const newBlob = new Blob([blob], { type: contentType });

      // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, name);
      } else {
        // For other browsers: create a link pointing to the ObjectURL containing the blob.
        const objUrl = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = objUrl;
        link.target = '_blank';
        link.download = name;
        link.click();

        // For Firefox it is necessary to delay revoking the ObjectURL.
        setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
      }
    },
    stringify: function(value: string) {
      if (value == undefined ||
          value == null) {
        return "";
      }

      return value;
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    formatISODate: function(data: Date) {
      const vm = this as any;

      let dateString = undefined;
      if (data !== undefined && data !== null) {
        dateString = vm.formatDate(new Date(data));
      }

      return dateString;
    },
    setDatePropertiesValue: function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneDaDate);
      vm.filtroRicerca.inizioCommercializzazioneA = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneADate);
      vm.filtroRicerca.fineCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneDaDate);
      vm.filtroRicerca.fineCommercializzazioneA = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneADate);
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    getIssuesTotal(issues: any[]) {
      if (issues) {
        const sum = issues.reduce((accumulator, issue) => {
          const value = parseInt(issue.value);
          if (isNaN(value)) {
            return accumulator;
          }

          return accumulator + value;
        }, 0);
        return sum;
      }

      return 0;
    },
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    openModalSuccess(msg: string) {
      const vm = this as any;
      vm.msgSuccess = msg;
      vm.$bvModal.show("modal-success");
    },
    closeModalSuccess() {
      const vm = this as any;
      vm.$bvModal.hide("modal-success");
    },
    onClickReturnSuccess() {
      const vm = this as any;
      vm.closeModalSuccess();
    },
    openModalError(msg: string) {
      const vm = this as any;
      vm.msgError = msg;
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    openModalConfirmOperation(msg: string, savedFilter: any) {
      const vm = this as any;
      vm.msgConfirmOperation = msg;
      vm.actualSavedFilter = savedFilter;
      vm.$bvModal.show("modal-confirm-operation");
    },
    closeModalConfirmOperation() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-operation");
    },
    onClickReturnConfirmOperation() {
      const vm = this as any;
      if (vm.operationToConfirm == "DELETE") {
        vm.salvaFiltroRicerca(vm.actualSavedFilter);
        vm.actualSavedFilter = null;
      }
      vm.operationToConfirm == "";
      vm.closeModalConfirmOperation();
    },    
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    getTooltipMsg: function(next: boolean) {
      const vm = this as any;

      let i = -1;
      let msg = "";
      if (next) {
        i = vm.slide + 1;
        if (i == Object.keys(vm.mapIndexSlide).length) {
          i = 0;
        }
      } else {
        i = vm.slide - 1;
        if (i < 0) {
          i = Object.keys(vm.mapIndexSlide).length - 1;
        }
      }

      msg = vm.mapIndexSlide[i].name ? vm.mapIndexSlide[i].name : vm.mapIndexSlide[i].fieldName;

      return msg;
    },
    jumpToDatabase(map: any, code: string, type: string, name: string) {
      const vm = this as any;

      let field: any = {};
      field.key = name;
      field.value = {code: code};
      if (type === 'min') {
        field.min = vm.getMinFromStatistics(map);
      }
      if (type === 'max') {
        field.max = vm.getMaxFromStatistics(map);
      }
      if (type === 'avg' || type === 'tot') {
        field.avg = true;
        field.tot = type === 'tot';
      }

      vm.filterDB(field);
    },
    openModalSalvaFiltroRicerca: function() {
      const vm = this as any;

      vm.$bvModal.show("modal-save-search-filter");
    },
    closeModalSalvaFiltroRicerca: function() {
      const vm = this as any;

      vm.$bvModal.hide("modal-save-search-filter");
    },
    salvaFiltroRicerca: async function(searchFilter: any) {
      const vm = this as any;

      let isInsert = false;
      let searchFilterId = undefined;
      let searchFilterState = undefined as any;
      if (searchFilter === undefined) {
        // caso primo salvataggio
        isInsert = true;
      } else if (searchFilter.searchFilterId === undefined) {
        // non dovrebbe mai entrare qui, ma prevediamo lo stesso il caso
        isInsert = true;
      } else {
        // caso accesso mediante funzione "Vedi" o caso delete (o altre future funzioni di update)
        searchFilterId = searchFilter.searchFilterId;
        searchFilterState = searchFilter.state;
      }

      if (isInsert && vm.isSearchFilterNameAlreadyPresent()) {
        vm.openModalError("Il nome attribuito al filtro di ricerca esiste già, specificare un nome non esistente.");
      } else {
        let filtroRicercaAndCategory = {
          category: vm.codCategoriaProdotto,
          searchFilterId: searchFilterId,
          searchFilterName: vm.nomeFiltroRicercaDaSalvare,
          dbSearchFilter: vm.filtroRicercaAdapted,
          changedFilterFields: vm.changedFilterFields,
          state: searchFilterState
        };

        const serviceCallReturnValue = await requestService
          .saveSearchFilter(
            filtroRicercaAndCategory
          )
          .then(handleResponse)
          /*.then((result: any) => {
            console.log(" result save filtro ricerca " + JSON.stringify(result));
            return result;
          })*/
          .then(() => {
            if (isInsert) {
              vm.closeModalSalvaFiltroRicerca();
            } else if (searchFilterState == "deleted") {
              vm.closeModalConfirmOperation();
            }
          })
          .then(() => {
            if (isInsert) {
              vm.openModalSuccess("Salvataggio filtro ricerca \"" + vm.nomeFiltroRicercaDaSalvare + "\" avvenuto con successo");
              vm.nomeFiltroRicercaDaSalvare = undefined;
            } else if (searchFilterState == "deleted") {
              vm.openModalSuccess("Cancellazione filtro ricerca \"" + searchFilter.searchFilterName + "\" avvenuto con successo");
            }
          })
          .catch(() => {
            vm.openModalError("Errore generico in salvaFiltroRicerca");
          });

        vm.getSearchFiltersList();
      }
    },
    isSearchFilterNameAlreadyPresent() {
      const vm = this as any;

      vm.getSearchFiltersList(); //popola vm.savedSearchFiltersList
      let isSearchFilterNameAlreadyPresent = false;
      vm.savedSearchFiltersList.forEach((item: any) => {
        if (item.searchFilterName == vm.nomeFiltroRicercaDaSalvare) {
          isSearchFilterNameAlreadyPresent = true;
        }
      });

      return isSearchFilterNameAlreadyPresent;
    },
    getSearchFiltersList: async function() {
      const vm = this as any;

      const serviceCallReturnValue = await requestService
        .getSearchFiltersList(
          vm.codCategoriaProdotto
        )
        .then(handleResponse)
        .then((result: any) => {
          vm.savedSearchFiltersList = result;
        })
        .catch(() => {
          vm.openModalError("Errore generico in getSearchFiltersList");
        });
    },
    populateSearchFilterWithSavedSearchFilter: async function(savedFilter: any) {
      const vm = this as any;

      vm.filtroRicerca.compagnia = savedFilter.dbSearchFilter.compagnia;
      vm.filtroRicerca.canale = savedFilter.dbSearchFilter.canale;
      vm.filtroRicerca.mercato = savedFilter.dbSearchFilter.mercato[0] === undefined ? undefined : savedFilter.dbSearchFilter.mercato[0].code;
      vm.filtroRicerca.distributori = savedFilter.dbSearchFilter.distributori;
      vm.filtroRicerca.modDistribuzione = savedFilter.dbSearchFilter.modDistribuzione;
      vm.filtroRicerca.ramo = savedFilter.dbSearchFilter.ramo[0] === undefined ? undefined : savedFilter.dbSearchFilter.ramo[0].code;
      vm.filtroRicerca.tipologiaGaranzie = savedFilter.dbSearchFilter.tipologiaGaranzie;
      if (savedFilter.dbSearchFilter.prodottoInCommercio == "Sì") {
        vm.filtroRicerca.prodottoInCommercio = true;
      } else if (savedFilter.dbSearchFilter.prodottoInCommercio == "No") {
        vm.filtroRicerca.prodottoInCommercio = false;
      }
      vm.filtroRicerca.inizioCommercializzazioneDaDate = vm.dateFromString(savedFilter.dbSearchFilter.inizioCommercializzazioneDa);
      vm.filtroRicerca.inizioCommercializzazioneADate = vm.dateFromString(savedFilter.dbSearchFilter.inizioCommercializzazioneA);
      vm.filtroRicerca.fineCommercializzazioneDaDate = vm.dateFromString(savedFilter.dbSearchFilter.fineCommercializzazioneDa);
      vm.filtroRicerca.fineCommercializzazioneADate = vm.dateFromString(savedFilter.dbSearchFilter.fineCommercializzazioneA);
      vm.filtroRicerca.inizioCommercializzazioneDa = savedFilter.dbSearchFilter.inizioCommercializzazioneDa;
      vm.filtroRicerca.inizioCommercializzazioneA = savedFilter.dbSearchFilter.inizioCommercializzazioneA;
      vm.filtroRicerca.fineCommercializzazioneDa = savedFilter.dbSearchFilter.fineCommercializzazioneDa;
      vm.filtroRicerca.fineCommercializzazioneA = savedFilter.dbSearchFilter.fineCommercializzazioneA;
      vm.filtroRicerca.tipoAssicurazione = savedFilter.dbSearchFilter.tipoAssicurazione[0] === undefined ? undefined : savedFilter.dbSearchFilter.tipoAssicurazione[0].code;
      vm.filtroRicerca.premioTipologia = savedFilter.dbSearchFilter.tipologiaPremio;
      vm.filtroRicerca.rischiAssicurati = savedFilter.dbSearchFilter.rischiAssicurati;

      //ordine applicazione filtri
      vm.changedFilterFields = savedFilter.changedFilterFields;
      if (vm.changedFilterFields == undefined || vm.changedFilterFields == null) {
        vm.changedFilterFields = [];
      }

      //triggera repopulateFiltersOptions per ripopolare le options di tutti i filtri in base ai filtri applicati
      if (savedFilter.changedFilterFields.length > 0) {
        let lastChangedFilterField = savedFilter.changedFilterFields[savedFilter.changedFilterFields.length - 1];
        vm.repopulateFiltersOptions(lastChangedFilterField);
      }

      vm.salvaFiltroRicerca(savedFilter);
    },
    setSearchFilterDeleted: async function(savedFilter: any) {
      const vm = this as any;

      savedFilter.state = "deleted";

      vm.operationToConfirm = "DELETE";
      const msg = "Vuoi cancellare il filtro ricerca \"" + savedFilter.searchFilterName + "\"?"
      vm.openModalConfirmOperation(msg,savedFilter);
    },
    isFilterOn() {
      const vm = this as any;

      if (vm.filtroRicerca.compagnia.length > 0 ||
        vm.filtroRicerca.canale.length > 0 ||
        vm.filtroRicerca.mercato !== undefined ||
        vm.filtroRicerca.distributori.length > 0 ||
        vm.filtroRicerca.modDistribuzione.length > 0 ||
        vm.filtroRicerca.ramo !== undefined ||
        vm.filtroRicerca.tipologiaGaranzie.length > 0 ||
        vm.filtroRicerca.prodottoInCommercio !== null ||
        vm.filtroRicerca.inizioCommercializzazioneDaDate !== undefined ||
        vm.filtroRicerca.inizioCommercializzazioneADate !== undefined ||
        vm.filtroRicerca.fineCommercializzazioneDaDate !== undefined ||
        vm.filtroRicerca.fineCommercializzazioneADate !== undefined ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.inizioCommercializzazioneDa == undefined ? "" : vm.filtroRicerca.inizioCommercializzazioneDa) ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.inizioCommercializzazioneA == undefined ? "" : vm.filtroRicerca.inizioCommercializzazioneA) ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.fineCommercializzazioneDa == undefined ? "" : vm.filtroRicerca.fineCommercializzazioneDa) ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.fineCommercializzazioneA == undefined ? "" : vm.filtroRicerca.fineCommercializzazioneA) ||
        vm.filtroRicerca.tipoAssicurazione !== undefined ||
        vm.filtroRicerca.premioTipologia.length > 0 ||
        vm.filtroRicerca.rischiAssicurati.length > 0) {

        return true;
      }

      return false;
    },
    isFilterOff() {
      const vm = this as any;

      return !vm.isFilterOn();
    },
  },
  created() {
    this.inizializzaFiltroRicerca();

    this.getPropertyValues()
      .then(result => {
        this.resetFilterOptions();
      });

    this.getStartingIssues();

    this.getSlidesIndexByName();

    this.getSearchFiltersList();
  },
  mounted() {
    const vm = this as any;
    if (!vm.loggedUser) {
      vm.homeProdotti();
    } else {
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const hasRole = vm.loggedUser.roles.indexOf('cpi-ppi') >= 0;

      if (!isAdmin && !hasRole) {
        vm.homeProdotti();
      }
    }

    const tooltip = jquery("<div></div>").addClass("chart-tooltip control-tooltip");
    tooltip.hide();
    jquery("body").append(tooltip);

    function show(next: boolean, event: any) {
      const msg = vm.getTooltipMsg(next); 
      jquery(".control-tooltip")
        .html(msg)
        .css("left", (event.pageX) + "px")
        .css("top", (event.pageY + 20) + "px")
        .show(200);
    }

    function hide() {
      jquery(".control-tooltip").hide();
    }

    jquery(".carousel-control-next-icon").on("mouseover", function(event) {
      show(true, event);
    });
    jquery(".carousel-control-prev-icon").on("mouseover", function(event) {
      show(false, event);
    });
    jquery(".carousel-control-next-icon").on("mouseout", function(event) {
      hide();
    });
    jquery(".carousel-control-prev-icon").on("mouseout", function(event) {
      hide();
    });
  },
  beforeDestroy() {
    jquery(".control-tooltip").remove();
  },
});
